'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { isCrossOriginIsolatedPathname } from '@/lib/route-policies'

export function SqliteLoader() {
  const pathname = usePathname()

  useEffect(() => {
    if (!isCrossOriginIsolatedPathname(pathname)) {
      return
    }

    // Load SQLite promiser script if not already loaded
    if (typeof window !== 'undefined') {
      if ('sqlite3Worker1Promiser' in window) {
        return
      }

      const script = document.createElement('script')
      script.src = '/sqlite/sqlite3-worker1-promiser.js'
      script.async = false
      script.onerror = () => {
        console.error('Failed to load sqlite3-worker1-promiser.js')
      }
      document.head.appendChild(script)
    }
  }, [pathname])

  return null
}
